import * as types from "../../constants"
import * as actions from "../actions-declarations/contracts";
import { ActionsOf, init } from "../utils";
import { IContract } from "../../models/Contract";

export type ContractsActions = typeof actions;

const defaultState: {contract: IContract | null} = { contract: null }

export default function reducer(
  state = init(defaultState),
  actions: ActionsOf<ContractsActions>): typeof state {
  switch (actions.type) {
    case types.FETCH_CONTRACT:
      return {
        ...state,
        contract: actions.payload
      };
    case types.CLEAR_CONTRACT:
      return {
        ...state,
        contract: null!
      }
    default:
      return state;
  }
}